import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
} from "@mui/material";
import { JumboCard } from "themes/jumbo/@jumbo/components";
import { ViewItem, EmptyViewItem } from "./ViewItem";
import { useSelector } from 'react-redux';
import { tss } from "tss-react";
import { useHistory } from 'react-router-dom';

const useStyles = tss.create(() => ({
  tableTr: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
    textAlign: 'left',
    padding: '16px',
    color: 'rgb(71, 82, 89)',
    borderTopColor: 'rgba(0, 0, 0, 0.1)',
    borderRightColor: 'rgba(0, 0, 0, 0.1)',
    bordTransform: 'uppercase',
    letterSpacing: '1.5px',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: 1.25,
    background: 'rgba(0, 0, 0, .08)'
  }
}));
const ViewsList = (props:any) => {
  const {nb} = props
	const _views = useSelector((state: any) => state.cache.data.views);
  const { classes } = useStyles();
  const history = useHistory();
  const storeAuthData = useSelector((state: any) => state.auth);
  const { defaultProjects } = storeAuthData;
  const demoProjectsHidden = Number(localStorage.getItem('hideDemoProjects') || 0) > 0;
  const views = Object.values(_views).filter((item: any) => !demoProjectsHidden || !defaultProjects.includes(item.project)) 
  

  const handleClick = (e: any) => {
      history.push(`/views`);
  };
  return (
    <JumboCard>
      <TableContainer sx={{height: '450px'}}>
        <Table /*sx={{ minWidth: 400 }}*/>
          <TableHead>
            <TableRow
              sx={{
                "th:first-of-type": {
                  pl: 3,
                },
                "th:last-child": {
                  pr: 3,
                },
              }}
            >
              <TableCell className={classes.tableTr} style={{width: '50%'}}>VIEWS {nb > 0 ? `(${nb})` : ''}</TableCell>
              <TableCell className={classes.tableTr} sx={{ display: {xs: 'none', sm: 'table-cell', md: 'table-cell', lg:'table-cell', xl: 'table-cell'}}}></TableCell>
              <TableCell className={classes.tableTr} style={{textAlign: 'right'}} sx={{ display: {xs: 'none', sm: 'none', md: 'table-cell', lg:'table-cell', xl: 'table-cell'}}}>
              <Button
                size={'small'}
                variant='outlined'
                onClick={handleClick}
					      sx={{ml: {xs: '-60px'}}}
              >
                All Views
              </Button>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {views.length > 0 ?  (
              views.filter((item: any) => item.project !== '58681264E77544F3907DD156FE847438').slice(0, 6).map((item: any, index: Number) => (
                <ViewItem item={item} key={`${item.ID}-${index}`} index={index} isDefaultProject={defaultProjects.includes(item.project)} />
              ))
            ) : (
              <EmptyViewItem />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </JumboCard>
  );
};
export { ViewsList };
